import {action, observable} from 'mobx';
import Container, {Service} from 'typedi';
import {
  ExportExcelDetailOcrDTO,
  ExportExcelOcrDTO,
  GetListRequestDTO,
  GetPdfReviewDTO,
  GetResultReviewDTO,
  RequestOcrDTO,
  UpdateResultDocumentDTO,
  UpdateStatusDownloadDTO,
  HttpService,
  ResponseDTO,
  UploadMultipleImageDTO,
  CancelRequestDTO,
  RetryRequestDTO,
} from '@/shared';

@Service()
export class RequestService {
  @observable
  private httpService = Container.get(HttpService);

  @action.bound
  public async getListRequest(
    getListOrcDTO: GetListRequestDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(getListOrcDTO);
  }

  public async createRequestOCR(
    requestOCRDTO: RequestOcrDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(requestOCRDTO);
  }
  public async exportExcelOCR(
    exportExcelOrcDTO: ExportExcelOcrDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(exportExcelOrcDTO);
  }
  public async exportExcelDetailOCR(
    exportExcelDetailOrcDTO: ExportExcelDetailOcrDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(exportExcelDetailOrcDTO);
  }
  public async UpdateStatusDownload(
    updateStatusDownloadDTO: UpdateStatusDownloadDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(updateStatusDownloadDTO);
  }
  public async getResultReview(
    getResultReviewDTO: GetResultReviewDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(getResultReviewDTO);
  }
  public async getPdfReview(
    getPdfReviewDTO: GetPdfReviewDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(getPdfReviewDTO);
  }
  public async upDateResultDocument(
    updateResultDocumentDTO: UpdateResultDocumentDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(updateResultDocumentDTO);
  }
  public async uploadMergeMultipleImage(
    uploadMultipleImageDTO: UploadMultipleImageDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(uploadMultipleImageDTO);
  }
  public async cancelRequest(
    cancelRequestDTO: CancelRequestDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(cancelRequestDTO);
  }
  public async retryRequest(
    retryRequestDTO: RetryRequestDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(retryRequestDTO);
  }
}
